import {
  Box, Card, CardBody, Flex, Stack, Text,
} from "@chakra-ui/react";
import { useParams } from "react-router";
import AppPage from "layouts/AppPage";
import { useEffect } from "react";
import { useNavbar } from "hooks/useNavbar";
import { usePrebuiltPathDetailQuery } from "features/Prebuilt/PrebuiltPath/hooks";
import QueryError from "components/Error/QueryError";
import { Heading22 } from "components/Heading";
import { ListPrebuiltTemplatesByPathId } from "features/Resources/SharedTemplate/Components/ListTemplatesByPathId";
import UsePrebuiltPathButton from "features/Prebuilt/PrebuiltPath/Components/UsePrebuiltPathButton";
import { Text18 } from "components/Text";

export default function ShowPrebuiltPathPage() {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, error: queryError } = usePrebuiltPathDetailQuery(id);
  const { setPageTitle } = useNavbar();

  useEffect(() => {
    if (data && !isLoading) {
      setPageTitle(data?.name);
    }
  }, [data, isLoading, setPageTitle]);

  if (data && queryError) {
    return <QueryError queryError={queryError} id={id} resourceName="Prebuilt Path" />;
  }

  return (
    <AppPage>
      <Card mt="8">
        <CardBody>
          <Stack gap="2">
            <Flex direction="row" align="center">
              {data?.emoji && (
                <Text mr={4} fontSize="30px" height="100%">
                  {data?.emoji}
                </Text>
              )}
              <Heading22 size="md">{data?.name}</Heading22>
            </Flex>
            {data && <Text18>{data?.description}</Text18>}
            {data && (
              <Box maxW="330px" mt="2">
                <UsePrebuiltPathButton prebuiltPath={data} />
              </Box>
            )}
          </Stack>
          <Box mt="4">
            {id && (
              <ListPrebuiltTemplatesByPathId prebuiltPathId={id} />
            )}
          </Box>
        </CardBody>
      </Card>
    </AppPage>
  );
}
